import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from '../../generals/Components';
import { BlogEditor } from '../../interfaces/interfaces';

@Component({
  selector: 'app-blogeditor',
  templateUrl: './blogeditor.component.html',
  styleUrls: ['./blogeditor.component.scss']
})
export class BlogeditorComponent extends UnsubscribeComponent implements OnDestroy, AfterViewInit {

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  blogId: number = null;
  blogEditor: BlogEditor = null;
  dataLoading = false;
  loading = false;
  blogEditorFormGroup: FormGroup = null;

  file: File = null;

  constructor(
    private apiService: ApiService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    super();
    this.blogId = this.config.data.blogId;
    this.init();
  }

  init(): void {
    this.initBlogEditorFormGroup();
    this.loadData();
  }

  initBlogEditorFormGroup(): void {
    this.blogEditorFormGroup = new FormGroup({
      title: new FormControl('', [Validators.required]),
      slug: new FormControl('', []),
      subTitle: new FormControl('', [Validators.required]),
      content: new FormControl('', [Validators.required]),
      active: new FormControl(false, [Validators.required])
    });
  }

  loadData(): void {
    if (this.blogId !== null) {
      this.dataLoading = true;
      this.apiService.getBlog(this.blogId).pipe(takeUntil(this.unsubscribe)).subscribe(({ blogEditor }) => {
        this.blogEditor = blogEditor;
        this.fillBlogEditorForm(this.blogEditor);
      }).add(() => {
        this.dataLoading = false;
      });
    }
  }

  fillBlogEditorForm(blogEditor: BlogEditor): void {
    this.blogEditorFormGroup.patchValue(blogEditor);
  }

  save(): void {
    if (this.blogEditorFormGroup.invalid) {
      return;
    }
    this.loading = true;
    const blogEditor: any = this.blogEditorFormGroup.value;
    if (this.blogId === null) {
      this.apiService.createBlog(blogEditor, this.file).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.ref.close(true);
      }).add(() => {
        this.loading = false;
      });
    } else {
      this.apiService.updateBlog(this.blogId, blogEditor, this.file).pipe(
        takeUntil(this.unsubscribe)
      ).subscribe(() => {
        this.ref.close(true);
      }).add(() => {
        this.loading = false;
      });
    }
  }

  close(result: boolean = false): void {
    this.ref.close(result);
  }

  fileUploadInputChanged(files: FileList): void {
    if (files.length > 0) {
      this.file = files.item(0);
    }
  }

  ngAfterViewInit(): void {
    this.input.nativeElement.focus();
  }
}
